export default "__VITE_ASSET__14374440__"